/* gd-combo-sticky.js — barra sticky da PDP de combo (creatina & cia), 20/Ago/2026.

   Duas correções, ambas restritas às PDPs em que o bloco `buy_buttons` virou
   <monte-seu-combo> (snippets/product-page.liquid: custom.product_variations
   preenchido E custom.bundle_habilitar_bundle == true):

   1. CLIQUE — o #show-sticky-product abria o painel de variantes do tema
      (body.show-mobile-options) e o #product-sticky-add-to-cart dava submit no form
      da barra, adicionando só a variante base. Nenhum dos dois compra o que a página
      vende: quem monta o pedido é o combo. Agora os dois rolam de volta pro combo,
      smooth (21/Ago/2026: o segundo botão entrou junto, o desktop caía no submit).

   2. VISIBILIDADE — a barra aparecia POR CIMA do próprio combo. Causa: o
      assets/sticky-add-to-cart.js mede os limites em
        getElementById("product-add-to-cart") || querySelector("[data-combo-addtocart]")
      e nenhum dos dois existe aqui — o #product-add-to-cart mora no
      snippets/product-button.liquid, que é exatamente o ramo {% else %} que o combo
      substitui, e o CTA do combo é [data-combo-buy]. Com stickyBounds null o
      offsetScroll vira 0 e a barra passa a aparecer no PRIMEIRO pixel de scroll.
      Aqui um IntersectionObserver esconde a barra enquanto o combo estiver na tela.

   POR QUE CLASSE PRÓPRIA E NÃO A `hidden-sticky` DO TEMA: o hide() do
   sticky-add-to-cart.js REMOVE a hidden-sticky a cada scroll fora dos limites, então
   marcação nossa naquela classe seria apagada. Na .gd-combo-onscreen só este arquivo
   mexe — e ela ganha da .always-on-mobile por !important.

   GUARDA: sem <monte-seu-combo> no DOM nada acontece (o painel do tema volta a abrir),
   então o asset é inofensivo se um dia for carregado numa PDP comum.

   ROLLBACK: remover a tag <script> do layout/theme.liquid (o gate por metafield).
*/
(function () {
  "use strict";

  var GAP = 12; // respiro entre o topo do combo e o que está grudado no topo
  var HIDE_CLASS = "gd-combo-onscreen";
  // Os dois CTAs da barra sticky: o #show-sticky-product (layout 1, o que aparece no
  // mobile) e o #product-sticky-add-to-cart (o submit do form, que é o que fica à
  // mostra no desktop). Nenhum dos dois compra a coisa certa numa PDP de combo — o
  // submit adicionaria só a variante base —, então ambos viram scroll pro combo.
  var TRIGGERS = "#show-sticky-product, #product-sticky-add-to-cart";
  var observer = null;

  function injectStyle() {
    if (document.getElementById("gd-combo-sticky-style")) return;

    var style = document.createElement("style");
    style.id = "gd-combo-sticky-style";
    style.textContent =
      ".productView-stickyCart." +
      HIDE_CLASS +
      "{opacity:0!important;visibility:hidden!important;pointer-events:none!important}";
    document.head.appendChild(style);
  }

  // Só entra na conta o que está REALMENTE fixo/sticky e cobrindo o topo agora:
  // a announcement-bar desta loja rola embora, e descontar altura de coisa que já
  // saiu da tela deixaria uma faixa em branco acima do combo. Uso o MAIOR `bottom`
  // em vez de somar as alturas porque o <sticky-header> vive dentro do
  // .section-header-navigation — somar contaria o header duas vezes.
  function topOverlayOffset() {
    var candidates = document.querySelectorAll(
      "sticky-header, .section-header-navigation, .announcement-bar"
    );
    var bottom = 0;

    for (var i = 0; i < candidates.length; i++) {
      var position = getComputedStyle(candidates[i]).position;
      if (position !== "fixed" && position !== "sticky") continue;

      var rect = candidates[i].getBoundingClientRect();
      if (rect.height === 0 || rect.top > 4) continue; // escondido ou já rolou pra fora
      if (rect.bottom > bottom) bottom = rect.bottom;
    }

    return bottom;
  }

  // Esconde a barra enquanto QUALQUER pedaço do combo estiver visível (threshold
  // default = 0). É de propósito: a barra só serve pra trazer o usuário de volta
  // pro combo, então com o combo em tela ela não tem função.
  function watchCombo() {
    if (!("IntersectionObserver" in window)) return;

    var combo = document.querySelector("monte-seu-combo");
    var sticky = document.querySelector(".productView-stickyCart");
    if (!combo || !sticky) return;

    if (observer) observer.disconnect();

    observer = new IntersectionObserver(function (entries) {
      var entry = entries[entries.length - 1];
      sticky.classList.toggle(HIDE_CLASS, entry.isIntersecting);
      if (entry.isIntersecting) {
        document.body.classList.remove("show-mobile-options");
      }
    });

    observer.observe(combo);
  }

  function scrollToCombo(combo) {
    // se o painel ficou aberto por um clique anterior (antes deste script carregar)
    document.body.classList.remove("show-mobile-options");

    var reduceMotion =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    var top =
      combo.getBoundingClientRect().top +
      window.pageYOffset -
      topOverlayOffset() -
      GAP;

    window.scrollTo({
      top: Math.max(top, 0),
      behavior: reduceMotion ? "auto" : "smooth",
    });
  }

  document.addEventListener(
    "click",
    function (event) {
      var trigger = event.target.closest && event.target.closest(TRIGGERS);
      if (!trigger) return;

      var combo = document.querySelector("monte-seu-combo");
      if (!combo) return; // PDP sem combo: deixa o botão fazer o que o tema manda

      // O handler do tema está no PRÓPRIO botão (sticky-add-to-cart.js -> openStickyModal),
      // então stopPropagation() na captura impede o evento de chegar até ele. Na fase de
      // bolha não daria: o painel já teria aberto. O preventDefault também é o que
      // segura o submit do #product-sticky-add-to-cart, que é type="submit".
      event.preventDefault();
      event.stopPropagation();

      scrollToCombo(combo);
    },
    true
  );

  // O #product-sticky-add-to-cart é type="submit": clicar nele já está coberto acima,
  // mas dar Enter no input de quantidade da barra dispara o submit sem passar por
  // clique nenhum. Mesmo tratamento, senão sobra um caminho que compra a variante base.
  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      if (!form || !form.querySelector) return;
      if (!form.querySelector("#product-sticky-add-to-cart")) return;

      var combo = document.querySelector("monte-seu-combo");
      if (!combo) return;

      event.preventDefault();
      event.stopPropagation();
      scrollToCombo(combo);
    },
    true
  );

  injectStyle();
  watchCombo();

  // O editor de tema re-renderiza a section e troca os nós: sem isto o observer
  // ficaria olhando um <monte-seu-combo> já descartado.
  document.addEventListener("shopify:section:load", watchCombo);
})();
